export type Colors = {
  bg: string;
  fg: string;
  muted: string;
  hair: string;
  cardBg: string;
  cardBorder: string;
  photoShadow: string;
  photoBorder: string;
  accent: string;
};

export function getColors(dark: boolean): Colors {
  return {
    bg: dark ? "#0a0a0a" : "#ffffff",
    fg: dark ? "#f5f5f5" : "#0a0a0a",
    muted: dark ? "#777" : "#999",
    hair: dark ? "#333" : "#e0e0e0",
    cardBg: dark ? "#111111" : "#f7f7f7",
    cardBorder: dark ? "#1e1e1e" : "#ebebeb",
    photoShadow: dark
      ? "0 28px 55px -22px rgba(0,0,0,0.85)"
      : "0 26px 50px -20px rgba(10,10,10,0.28)",
    photoBorder: dark ? "1px solid #262626" : "1px solid rgba(10,10,10,0.06)",
    accent: dark ? "#ff6b6b" : "#c0392b",
  };
}
